import { useRouteQuery, useTranslator } from '@/hooks'
import dayjs from 'dayjs'
import { Button } from '@/@core/components/mui/Button'
import { useMemo } from 'react'

interface AttendanceEmployeePayrollProps {
  dataEmployee: any
  setIsEditPayroll: (isEditPayroll: boolean) => void
  isDisabledEditPayroll: boolean
}

export const AttendanceEmployeePayroll = ({
  dataEmployee,
  setIsEditPayroll,
  isDisabledEditPayroll
}: AttendanceEmployeePayrollProps) => {
  const { __, __n } = useTranslator()
  const { searchQuery } = useRouteQuery()

  const currentMonthDisplay = useMemo(() => {
    const monthParam = searchQuery.get('month')

    if (monthParam) {
      return dayjs(monthParam).format('MMMM YYYY')
    }

    return dayjs().format('MMMM YYYY')
  }, [searchQuery.get('month')])

  return (
    <div className='p-5'>
      <div className='flex items-center gap-2 justify-between border-b border-[#2f2b3d1f] pb-2'>
        <div className='text-[18px] font-medium text-[#2f2b3d]'>
          {__('Payroll')} {currentMonthDisplay}
        </div>
        {!isDisabledEditPayroll && (
          <Button
            variant='outlined'
            size='small'
            startIcon={<i className='tabler-settings'></i>}
            className='border-blue-500 text-blue-600 hover:border-blue-600'
            onClick={() => {
              setIsEditPayroll(true)
            }}
            disabled={isDisabledEditPayroll}
          >
            <span className='text-[15px] font-medium'>{__('Edit Payroll')}</span>
          </Button>
        )}
      </div>

      <div className='grid grid-cols-4 gap-x-3 gap-y-5 mt-3'>
        <div className='flex items-start gap-2'>
          <div>
            <img src='/images/icons/gross_pay.png' alt='avatar' className='w-[40px] h-[40px]' />
          </div>
          <div>
            <div className='text-[18px] font-medium text-[#2f2b3de6]'>{__n(dataEmployee?.data?.data?.gross_pay)}</div>
            <div className='text-[13px] font-normal text-[#2f2b3db3]'>{__('Gross Pay')}</div>
          </div>
        </div>
        <div className='flex items-start gap-2'>
          <div>
            <img src='/images/icons/net_pay.png' alt='avatar' className='w-[40px] h-[40px]' />
          </div>
          <div>
            <div className='text-[18px] font-medium text-[#2f2b3de6]'>{__n(dataEmployee?.data?.data?.net_pay)}</div>
            <div className='text-[13px] font-normal text-[#2f2b3db3]'>{__('Net Pay')}</div>
          </div>
        </div>
        <div className='flex items-start gap-2'>
          <div>
            <img src='/images/icons/daily_wage.png' alt='avatar' className='w-[40px] h-[40px]' />
          </div>
          <div>
            <div className='text-[18px] font-medium text-[#2f2b3de6]'>{__n(dataEmployee?.data?.data?.daily_wage)}</div>
            <div className='text-[13px] font-normal text-[#2f2b3db3]'>{__('Daily Wage')}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
